/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_FailedInputs */



/**
* | output |
* | --- |
* | "We could not load your 1:1s. Please try again in a moment." |
*
* @param {Team_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_failed = /** @type {((inputs?: Team_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("We konden je 1:1's niet laden. Probeer het zo meteen opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nous n'avons pas pu charger vos one-to-ones. Réessayez dans un instant.")
	return /** @type {LocalizedString} */ ("We could not load your 1:1s. Please try again in a moment.")
});